import Api from './api';

const slug = 'v1/roleplay-saved-scenarios';
export default {
  getAll(scenarioId) {
    const params = scenarioId ? `?scenarioId=${scenarioId}` : '';
    return Api.get(`/${slug}${params}`).then(res => res.data);
  },
  create(data) {
    return Api.post(`/${slug}`, data).then(res => res.data);
  },
  remove(id) {
    return Api.delete(`/${slug}/${id}`).then(res => res.data);
  },
};
